import EmailIcon from "@mui/icons-material/Email";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import PictureAsPdfSharpIcon from "@mui/icons-material/PictureAsPdfSharp";
import { IconButton, Tooltip } from "@mui/material";
import { useDispatch } from "react-redux";
import { downloadPDFContrato } from "../../../redux/actions/contrato";
import { downloadFile } from "../../../util/files";
import { StyledContratoCard } from "../../styled/Empresa";



const ContratoCard = ({ nombreContrato, openModal, codigoContrato }) => {
  const dispatch = useDispatch();

  const handleDownloadPDF = () => {
    dispatch(downloadPDFContrato(codigoContrato)).then((response) => {
      downloadFile(response.value.data, `${nombreContrato}.pdf`);
    });
  };

  return (
    <StyledContratoCard.Container elevation={3}>
      <StyledContratoCard.ContainerIcon>
        <StyledContratoCard.Icon as={PictureAsPdfSharpIcon} sx={{ fontSize: 40 }} />
        <StyledContratoCard.Text>{nombreContrato}</StyledContratoCard.Text>
      </StyledContratoCard.ContainerIcon>
      <StyledContratoCard.ContainerIcon>
        <Tooltip title="Enviar por email" arrow>
          <IconButton 
            onClick={() => openModal(codigoContrato)}
            sx={{ 
              color: (theme) => theme.palette.primary.main,
              marginRight: "15px"
            }}
          >
            <EmailIcon sx={{ fontSize: 30 }} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Descargar" arrow>
          <IconButton 
            onClick={handleDownloadPDF}
            sx={{ 
              color: (theme) => theme.palette.primary.main,
              marginRight: "15px"
            }}
          >
            <FileDownloadIcon sx={{ fontSize: 30 }} />
          </IconButton>
        </Tooltip>
      </StyledContratoCard.ContainerIcon>
    </StyledContratoCard.Container>
  );
};

export default ContratoCard;
